import { FC } from 'react'
import { RouteComponentProps } from 'react-router'

import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import GuideClientContents from '../components/GuideClientContents'

const GuideClientContentsRoute: FC<RouteComponentProps & { isForScreens: boolean }> = ({ isForScreens }) => {
	return <GuideClientContents isForScreens={isForScreens} />
}

export default WithContainerRoute(GuideClientContentsRoute)
